import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ICiudad } from '../models/ciudad';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CiudadService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.SUrlgApi + 'Ciudades';
  }

  getListadoCiudades(): Observable<ICiudad[]> {
    return this.http
      .get<ICiudad[]>(this.apiUrl)
      .pipe(retry(1), catchError(this.handleError));
  }
  getListadoCiudadesPrincipales(data:number): Observable<ICiudad[]> {
     const valores = {
      params: new HttpParams().
        set('opcion', data)
    };
    return this.http
      .get<ICiudad[]>(this.apiUrl+"/GetCiudades/",valores)
      .pipe(retry(1), catchError(this.handleError));
  }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
